import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import LibraryService from '../../core/service'

// get type data Category
export const getFileCategory = createAsyncThunk(
  'library/downloadFile/getFileCategory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getFileCategory(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

// get data Table
export const getDownloadFile = createAsyncThunk(
  'library/downloadFile/getDownloadFile',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getDownloadFile(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getType getTypeReportFileFormat
export const getTypeReportFileFormat = createAsyncThunk(
  'library/downloadFile/getTypeReportFileFormat',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getTypeReportFileFormat(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//getHeaderDownloadFile
export const getHeaderDownloadFile = createAsyncThunk(
  'library/downloadFile/getHeaderDownloadFile',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getHeaderDownloadFile(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
